module.exports = __webpack_public_path__ + "static/MC_steps_nuevos_FISICA_4_B-4532a9f4119b7471413719da75ac08c2.gif";